export default __webpack_public_path__ + "static/media/inventary-for-sale.6f37f1a8.jpg";